/** Success固定 Mockレスポンス */
const Success = {
  result: 'success',
};

export default Success;
